import axios, { AxiosError } from "axios";
import { MessageInstance } from "antd/es/message/interface";

export const ErrorHelper = {
  isAxiosError(error: unknown): error is AxiosError {
    return axios.isAxiosError(error);
  },
  async handleAxiosErrorMessage(
    error: AxiosError,
    messageApi: MessageInstance
  ) {
    const res = error.response;
    // 無回傳資料 => 顯示預設訊息
    if (!res) {
      await messageApi.error("請求失敗");
      return;
    }

    const msg = (res?.data as any)?.msg;
    // 有回傳資料且 msg 為字串 => 顯示回傳訊息
    if (typeof msg === "string") {
      await messageApi.error(msg);
      return;
    }

    // 有回傳資料但 msg 格式不是字串 => 轉成字串來顯示
    await messageApi.error(JSON.stringify(msg));
  },
};
